module.exports = __webpack_public_path__ + "static/media/FacebookJobIcon.0aca0aed.svg";